module.exports = __webpack_public_path__ + "static/media/Child.e1e54535.svg";